<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_CustomsDeclarationInformationOujian')"
    width="800px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :from-lob="cloudFile.fromLob"
      :file-size="cloudFile.fileSize"
      :upload-files="cloudFile.uploadFiles"
      @uploadDone="updateSop"
    />
    <el-form label-width="100px" label-position="left">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.SequenceNumber')">
            <el-input v-model="oneFormData.level" style="width: 260px" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.StatusOfCustomsDeclaration')" class="custom" style="margin-left: 10px;">
            <el-select v-model="oneFormData.declareCustomsState" disabled style="width:250px">
              <el-option :label="$t('SeaExport.PleaseSelect')" :value="0" />
              <el-option :label="$t('SeaExport.Recorded')" :value="1" />
              <el-option :label="$t('SeaExport.ListPulled')" :value="2" />
              <el-option :label="$t('SeaExport.AtReception')" :value="3" />
              <el-option :label="$t('SeaExport.CustomsDeclared')" :value="4" />
              <el-option :label="$t('SeaExport.Undeclared')" :value="5" />
              <el-option :label="$t('SeaExport.CustomsExamination')" :value="6" />
              <el-option :label="$t('SeaExport.InspectionExamination')" :value="7" />
              <el-option :label="$t('SeaExport.ExamedWithoutReleasing')" :value="8" />
              <el-option :label="$t('SeaExport.AmendDeclaration')" :value="9" />
              <el-option :label="$t('SeaExport.NotifyToDeclare')" :value="10" />
              <el-option :label="$t('SeaExport.CustomsHasCheck')" :value="11" />
              <el-option :label="$t('SeaExport.CustomsExamed')" :value="12" />
              <el-option :label="$t('SeaExport.CustomsOneRelease')" :value="13" />
              <el-option :label="$t('SeaExport.CustomsRelease2')" :value="14" />
              <el-option :label="$t('SeaExport.hasBeanSend')" :value="15" />
              <el-option :label="$t('SeaExport.notSend')" :value="16" />
              <el-option :label="$t('SeaExport.sendFailed')" :value="17" />
              <el-option :label="$t('SeaExport.SelfDeclaration')" :value="18" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.TenBitCode')" class="custom">
            <cargo-advance-select
              filterable
              :default-value="oneFormData.tenDigitCode"
              :cache="false"
              :allow-create="true"
              tag-name="tenDigitCode"
              tag-value="tenDigitCode"
              style="width:260px"
              options-width="260px;"
              :static-options="bussinessList"
              @parentCallBack="tenDigitCodeChangeHandler"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OperatingCompany')" class="custom" style="margin-left: 10px;">
            <cargo-advance-select
              filterable
              :default-value="oneFormData.companyCname"
              :cache="false"
              :allow-create="true"
              tag-name="companyCname"
              tag-value="companyCname"
              style="width:250px"
              options-width="250px;"
              :static-options="bussinessList"
              @parentCallBack="queryBusinessHandler"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.BusinessNo')">
            <el-input v-model="job.jobNo" :disabled="true" style="width: 260px" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomsNo')" style="margin-left: 10px;">
            <el-input v-model="oneFormData.customsNo" style="width: 250px" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isSe || isSi">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Vessel')">
            <el-input v-model="job.vessel" :disabled="true" style="width: 260px" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Voyage')" style="margin-left: 10px;">
            <el-input v-model="job.voyageFlight" :disabled="true" style="width: 250px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--海进mbl/hbl-->
      <el-row v-if="isSi">
        <el-col :span="12">
          <el-form-item label="MBL No">
            <!--txtMblNo-->
            <el-input v-if="job.typeMBL !== 2" v-model="oneFormData.mblNo" :disabled="true" />
            <el-select v-if="job.typeMBL === 2" v-model="oneFormData.mblNo">
              <el-option v-for="(value) in mbls" :key="value" :label="value" :value="value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="HBL No" style="margin-left: 10px;">
            <!--txtHblNo-->
            <el-input v-if="job.typeHBL !== 2" v-model="oneFormData.hblNo" :disabled="true" />
            <el-select v-if="job.typeHBL === 2" v-model="oneFormData.hblNo">
              <el-option v-for="(value) in hbls" :key="value" :label="value" :value="value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--空进MAMB/HAMB-->
      <el-row v-if="isAi">
        <el-col :span="12">
          <el-form-item label="MAMB No">
            <el-input v-model="txtMawbNo" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="HAWB No" style="margin-left: 10px;">
            <el-input v-model="oneFormData.hblNo" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="isSe" :span="12">
          <el-form-item label-width="0">
            <div style="display: inline-block;width: 100px">
              <span style="color: red">*</span>
              <span>{{ $t('SeaExport.SoNo') }}</span>
            </div>
            <el-select v-if="job.booking" v-model="oneFormData.soNo" style="width: 260px">
              <el-option v-for="(value) in soNoList" :key="value" :label="value" :value="value" />
            </el-select>
            <el-input v-if="!job.booking" v-model="oneFormData.soNo" style="width: 260px" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="0">
            <div v-if="isSe" style="display: inline-block;width: 10px" />
            <div style="display: inline-block;width: 100px;">
              <span style="color: red">*</span>
              <span>{{ $t('SeaExport.CustomsBroker') }}</span>
            </div>
            <cargo-advance-select
              v-if="isSe"
              style="display: inline-block;width: 250px"
              filterable
              :method-params="{customsBroker:true,active:true}"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="oneFormData.customsBroker"
              tag-name="chineseName"
              @parentCallBack="item=>oneFormData.customsBroker=item.value"
            />
            <cargo-advance-select
              v-if="!isSe"
              style="display: inline-block;width: 260px"
              filterable
              :method-params="{customsBroker:true,active:true}"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="oneFormData.customsBroker"
              tag-name="chineseName"
              @parentCallBack="item=>oneFormData.customsBroker=item.value"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="isAe" :span="12">
          <el-form-item label="AWB NO" style="margin-left: 10px;">
            <el-input v-model="txtAwbNo" :disabled="true" style="width: 250px" />
          </el-form-item>
        </el-col>
        <el-col v-if="isAi" :span="12">
          <el-form-item :label="$t('SeaExport.GoodsStoragePlace')" style="margin-left: 10px;">
            <el-input v-model="oneFormData.goodsStoragePlace" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label-width="0">
            <div style="display: inline-block;width: 100px">
              <span style="color: red">*</span>
              <span>{{ $t('SeaExport.BusinessType') }}</span>
            </div>
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.local_cache_SystemConstants$OJ_LOBS"
              :default-value="oneFormData.lob"
              style="display: inline-block;width: 260px"
              @parentCallBack="item=>oneFormData.lob=item.code"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.DateOfCustomsDeclaration')" style="margin-left: 10px;">
            <el-date-picker
              v-model="oneFormData.customsDate"
              style="width:250px"
              type="date"
              :clearable="false"
              :editable="false"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isSi && isLcl">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.DistributionNo')" class="custom">
            <el-input v-model="oneFormData.distributionNo" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.DistributionWarehouse')" class="custom" style="margin-left: 10px;">
            <el-input v-model="oneFormData.distributionWarehouse" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isSe || isSi">
        <el-col v-if="isSe" :span="12">
          <el-form-item class="custom" label-width="0">
            <div style="display: inline-block;width: 100px">
              <span style="color: red">*</span>
              <span>{{ $t('SeaExport.PreDateOfCustomsDeclaration') }}</span>
            </div>
            <el-date-picker
              v-model="oneFormData.preCustomsDate"
              type="date"
              :clearable="false"
              :editable="false"
              format="yyyy-MM-dd"
              style="width: 260px"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="isSi || isAi" :span="12">
          <el-form-item class="custom" label-width="0">
            <span style="display: inline-block;width: 140px">{{ $t('SeaExport.ExchangeService') }}</span>
            <el-radio-group v-model="oneFormData.exchangeService">
              <el-radio :label="1">{{ $t('SeaExport.Yes') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="isSi && !isLcl" :span="12">
          <el-form-item class="custom" label-width="0">
            <span style="display: inline-block;width: 100px;margin-left: 10px">{{ $t('SeaExport.BillOfLading') }}</span>
            <el-input v-model="oneFormData.billOfLading" style="width: 250px" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isAe || isAi">
        <el-col :span="12">
          <el-form-item label-width="0">
            <div style="display: inline-block;width: 100px">
              <span style="color: red">*</span>
              <span>{{ $t('SeaExport.AirportPort') }}</span>
            </div>
            <el-input v-model="oneFormData.airportPort" style="width: 260px" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isSi || isAi">
        <el-col :span="12">
          <el-form-item class="custom" label-width="0">
            <span style="display: inline-block;width: 140px">{{ $t('SeaExport.SpecialRelationshipOfBuyer') }}</span>
            <el-radio-group v-model="oneFormData.specialRelationshipOfBuyer">
              <el-radio :label="1">{{ $t('SeaExport.Yes') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="custom" label-width="0">
            <span style="display: inline-block;width: 140px;margin-left: 10px;">{{ $t('SeaExport.IncludeRoyalty') }}</span>
            <el-radio-group v-model="oneFormData.includeRoyalty">
              <el-radio :label="1">{{ $t('SeaExport.Yes') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="isAi" :span="12">
          <el-form-item class="custom" label-width="0">
            <span style="display: inline-block;width: 140px;">{{ $t('SeaExport.ExchangeServiceAi') }}</span>
            <el-radio-group v-model="oneFormData.exchangeService">
              <el-radio :label="1">{{ $t('SeaExport.Yes') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="isSi || isAi" :span="12">
          <el-form-item class="custom" label-width="0">
            <span style="display: inline-block;width: 140px;">{{ $t('SeaExport.AffectPrice') }}</span>
            <el-radio-group v-model="oneFormData.affectPrice">
              <el-radio :label="1">{{ $t('SeaExport.Yes') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="isSi" :span="12">
          <el-form-item class="custom" label-width="0">
            <div style="display: inline-block;width: 140px;margin-left: 10px;">
              <span style="color: red">*</span>
              <span>{{ $t('SeaExport.WoodPacking') }}</span>
            </div>
            <el-radio-group v-model="oneFormData.woodPacking">
              <el-radio :label="1">{{ $t('SeaExport.Yes') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span style="color: red">*</span>
          <span>{{ $t('SeaExport.CustomsInformation') }}</span>
          <el-button type="primary" style="margin-left: 48px" @click="toQuery">{{ $t('FileHistory.Refresh') }}</el-button>
          <el-button type="primary" style="margin-left: 10px" @click="shouCloudUpload">{{ $t('SeaExport.AddFile') }}</el-button>
          <el-button type="danger" style="margin-left: 10px" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          <span style="margin-left: 10px;color: red">{{ $t('Message.ReminderOfTheCustomsData') }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="custom" style="margin-top: 5px">
            <div style="height: 200px">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="width:100%;height:180px"
                @gridReady="params=>gridApi=params.api"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')" style="width: 100%">
            <div>
              <el-input v-model="oneFormData.remarks" type="textarea" :rows="3" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="enterHandler(2)">{{ $t('SeaExport.Send') }}</el-button>
      <el-button type="primary" @click="enterHandler(1)">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as customsInfoApi from '@/api/seaExport/customsInfo'
import { getBusinessByCompany, getBusinessByTenDigitCode, businessCheckSaveUpdate } from '@/api/seaExport/file'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import * as SEConst from '@/class/cargo/model/parameters/SeaExportConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { getFileList, deleteFile } from '@/api/storage'
import { sortByMultiField } from '@/utils'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { DocumentManage } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { getLoading } from '@/utils/utilBaseElement'
import { getJobByUuid } from '@/api/booking/job'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { getSoNos } from '@/api/seaExport/customsInfo'
import URL from '@/api/urlTranslator'

export default {
  name: 'CustomsInfoDialogOuj',
  components: { cargoCloudFileUpload, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    job: {
      type: Object,
      required: true
    },
    selectedCustomsInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isNew: false,
      isEdit: false,
      isExport: false,
      isQuerying: false,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      customsDeclarationTypes: [...SEConst.DECLARE_CUSTOMS_TYPES],
      business: {},
      soNoList: [],
      mbls: [],
      hbls: [],
      bussinessList: [],
      currentUser: {},
      oneFormData: {
        level: '',
        tenDigitCode: '',
        companyCname: '',
        customsNo: '',
        mblNo: '',
        hblNo: '',
        soNo: '',
        goodsStoragePlace: '',
        lob: '',
        customsDate: '',
        distributionNo: '',
        distributionWarehouse: '',
        preCustomsDate: '',
        billOfLading: '',
        airportPort: '',
        declareCustomsState: 0,
        customsBroker: 0,
        exchangeService: 2,
        specialRelationshipOfBuyer: 2,
        includeRoyalty: 2,
        affectPrice: 2,
        woodPacking: 2,
        remarks: ''
      },
      txtAwbNo: '',
      txtAirportPort: '',
      txtMawbNo: '',
      txtHawbNo: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SeaExport.FileType'),
          field: 'fileType',
          width: 100,
          cellRenderer: params => {
            return (params.value || '').toUpperCase()
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FileName'),
          field: 'fileName',
          width: 140
        }, {
          headerName: this.$t('Partners.UploadTime'),
          field: 'createDate',
          width: 140
        }, {
          headerName: this.$t('FileHistory.view'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.view')}</a>`
          }
        }
      ],
      rowData: [],
      gridApi: null,
      gridApiFileDetail: null,
      gridOptionsFileDetail: {
        context: {
          componentParent: this
        }
      },
      cloudFile: {
        visible: false,
        job: {
          lob: 'SE'
        },
        lob: 'SE',
        fromLob: '',
        fileSize: 20480000
      },
      documentManage: new DocumentManage(),
      docType: [],
      isSe: false,
      isSi: false,
      isAe: false,
      isAi: false,
      isRe: false,
      isLcl: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        // this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async onShow() {
      console.log(this.job)
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      this.configMap = cache.config
      this.initForm()
      const obj = new CustomsInfo(this.selectedCustomsInfo).getData()
      Object.assign(this.oneFormData, obj)
      this.oneFormData.customsBroker = !this.oneFormData.uuid ? this.job.customsBroker : this.oneFormData.customsBroker
      console.log(this.oneFormData)
      this.showModelView()
      await this.initData()
    },
    // 初始化shi
    async initData() {
      await getBusinessByCompany('%', true).then(res => {
        this.bussinessList = res.data
      })
    },
    async showModelView() {
      this.soNoList = []
      this.isExport = this.job.lob === 'SE'
      const soNo = this.job.lob === 'SE' ? this.job.soNo : this.job.jobSoNo
      console.log(soNo)
      if (soNo != null && soNo !== '') {
        const soNoArray = soNo.split('\n')
        for (const value of soNoArray) {
          this.soNoList.push(value)
        }
      }
      getSoNos({ jobUuid: this.job.uuid }).then(res => {
        if (res.data) {
          for (const item of res.data) {
            if (item && item.trim().length > 0) {
              if (!this.soNoList.includes(item)) {
                this.soNoList.push(item)
              }
            }
          }
        }
      })

      const customsInfo = this.oneFormData
      if (customsInfo && !customsInfo.uuid) {
        customsInfo.soNo = this.soNoList.length > 0 ? String(this.soNoList[0]) : null
      }

      if (!StrUtils.isEmpty(customsInfo.soNo) && !this.soNoList.includes(customsInfo.soNo)) {
        this.soNoList.push(customsInfo.soNo)
      }
      if (this.isSi) {
        if (this.job.typeMBL === 1) {
          customsInfo.mblNo = this.job.mbl
        } else if (this.job.typeMBL === 2) {
          const cargoDocs = await new SeaImportJob(this.job).getCargoDoc()
          for (const doc of cargoDocs) {
            if (doc.docType === 'MBL2' && !this.mbls.includes(doc.hblNbr2)) {
              this.mbls.push(doc.hblNbr2)
            }
          }
          if (this.mbls.length > 0) {
            this.oneFormData.mblNo = this.mbls[0]
          }
        } else if (this.job.typeMBL === 3) {
          const cargoDocs = await new SeaImportJob(this.job).getCargoDoc()
          for (const doc of cargoDocs) {
            if (doc.docType === 'MBL2') {
              customsInfo.mblNo = doc.mblNbr2
              break
            }
          }
        }
        if (this.job.typeHBL === 1) {
          const cargoDocs = await new SeaImportJob(this.job).getCargoDoc()
          for (const doc of cargoDocs) {
            if (doc.docType === 'HBL') {
              customsInfo.hblNo = doc.hblNbr2
              break
            }
          }
        } else if (this.job.typeHBL === 2) {
          const cargoDocs = await new SeaImportJob(this.job).getCargoDoc()
          for (const doc of cargoDocs) {
            if (doc.docType === 'HBL2' && !this.hbls.includes(doc.hblNbr2)) {
              this.hbls.push(doc.hblNbr2)
            }
          }
          if (this.hbls.length > 0) {
            this.oneFormData.hblNo = this.hbls[0]
          }
        } else if (this.job.typeHBL === 3) {
          const cargoDocs = await new SeaImportJob(this.job).getCargoDoc()
          for (const doc of cargoDocs) {
            if (doc.docType === 'HBL2') {
              customsInfo.hblNo = doc.hblNbr2
              break
            }
          }
        }
      }
      if (this.isAe) {
        const aeJob = this.job
        // AWB NO
        this.txtAwbNo = AirExportUtils.mawbNoDispalyFormat(aeJob.mbl)
        // 机场口岸
        if (this.oneFormData.airportPort === '' || this.oneFormData.airportPort === null) {
          this.oneFormData.airportPort = this.job.loadingPortCode === null ? '' : this.job.loadingPortCode
        }
      }
      if (this.isAi) {
        const aiJob = this.job
        // 机场口岸
        if (this.oneFormData.airportPort === '' || this.oneFormData.airportPort === null) {
          this.oneFormData.airportPort = this.job.loadingPortCode === null ? '' : this.job.loadingPortCode
        }
        if (aiJob.operateType === 0 || aiJob.operateType === 2) {
          // MAWB NO
          this.txtMawbNo = AirExportUtils.mawbNoDispalyFormat(aiJob.mbl)
          // HAWB NO
          const cargoDocs = await new AirImportJob(this.job).getAirCargoDoc()
          for (const doc of cargoDocs) {
            if (doc.docType === 'HAWB') {
              this.oneFormData.hblNo = doc.hblNbr2
              break
            }
          }
        } else {
          // MAWB NO
          this.txtMawbNo = aiJob.mbl
        }
      }
      this.toQuery()
    },
    async enterHandler(fromType) {
      const soNoNotEmpty = parseInt(cache.config.get('SoNoNotEmpty')) === 1
      if (!soNoNotEmpty && !this.oneFormData.soNo && (this.job.preverifyState === 2 || this.job.jobState === SystemConstants.STATE_OPERATING.code)) {
        this.$message.warning(this.$t('Message.SoNoCannotBeNull'))
        return
      }
      await this.saveFile(fromType)
    },
    async saveFile(fromType) {
      const customsInfo = this.oneFormData
      if (customsInfo == null) return
      this.oneFormData.fromType = fromType
      this.oneFormData.jobUuid = this.job.uuid
      this.job.customsBroker = customsInfo.customsBroker
      if (fromType === 2) {
        if (StrUtils.isEmpty(this.job.mbl)) {
          if (this.job.lob === 'SI') {
            this.$message.warning(this.$t('Message.SelectMBLSI'))
          } else if (this.job.lob === 'AE') {
            this.$message.warning(this.$t('Message.SelectMBLAE'))
          } else if (this.job.lob === 'AI') {
            this.$message.warning(this.$t('Message.SelectMBLAI'))
          } else {
            this.$message.warning(this.$t('Message.SelectMBL'))
          }
          return
        }
        if (!customsInfo.customsBroker || customsInfo.customsBroker === 0) {
          this.$message.warning(this.$t('Message.SelectCustomsBroker'))
          return
        }

        // 验证关单号
        if (this.isSe) {
          if (StrUtils.isEmpty(customsInfo.soNo)) {
            this.$message.warning(this.$t('Message.PleaseSelectSoNo'))
            return
          }
        }
        if (StrUtils.isEmpty(customsInfo.lob)) {
          this.$message.warning(this.$t('Message.SelectLob'))
          return
        }

        const customsBrokerCompany = await Company.getCompanyById(customsInfo.customsBroker)
        if (!customsInfo.customsBroker || StrUtils.isEmpty(customsBrokerCompany.platformProvider)) {
          this.$message.warning(this.$t('Message.SelectCustomsBrokerPlatFormProvider'))
          return
        }
        if (this.isSe) {
          if (StrUtils.isEmpty(customsInfo.portDistrict)) {
            this.$message.warning(this.$t('Message.SelectHarborDistrictSe'))
            return
          }
          if (!customsInfo.preCustomsDate) {
            this.$message.warning(this.$t('Message.SelectPreCustomsDate'))
            return
          }
        }
        if (this.isSi) {
          if (StrUtils.isEmpty(customsInfo.portDistrict)) {
            this.$message.warning(this.$t('Message.SelectHarborDistrictSi'))
            return
          }
          if (StrUtils.isEmpty(this.job.destinationPlace)) {
            this.$message.warning(this.$t('Message.DestinationPlaceNotNull'))
            return
          }
        }
        if (this.isAe) {
          if (StrUtils.isEmpty(customsInfo.airportPort)) {
            this.$message.warning(this.$t('Message.AirportPortNotNull'))
            return
          }
        }
        if (this.isAi) {
          if (StrUtils.isEmpty(customsInfo.airportPort)) {
            this.$message.warning(this.$t('Message.AirportPortNotNull'))
            return
          }
          if (!this.job.eta) {
            this.$message.warning(this.$t('Message.ExpectedDateOfArrivalNotNull'))
            return
          }
          if (!this.job.destinationPlace) {
            this.$message.warning(this.$t('Message.DestinationPlaceNotNull'))
            return
          }
        }

        if (!this.rowData || this.rowData.length === 0) {
          this.$message.warning(this.$t('Message.SelectCustomsFiles'))
          return
        }
        // if (customsInfo.declareCustomsState === 15) {
        //   this.$message.warning(this.$t('Message.CustomsHasBeanSend'))
        //   return
        // }
        if (this.isSe || this.isSi) {
          if (StrUtils.isEmpty(this.job.vessel) || StrUtils.isEmpty(this.job.voyageFlight)) {
            await this.$confirm(this.$t('Message.VesselAndvVoyageFlightisEmpty'))
          }
        }
      }
      const job = {}
      job.uuid = this.job.uuid
      job.mbl = this.job.mbl
      job.eta = this.job.eta
      job.portDistrict = this.job.portDistrict
      job.destinationPlace = this.job.destinationPlace ? this.job.destinationPlace : ''
      job.jobSoNo = customsInfo.soNo
      job.soNo = customsInfo.soNo
      customsInfo.job = job
      customsInfo.mblNo = job.mbl
      const loading = getLoading()
      customsInfoApi.saveOrSend(customsInfo).then(resp => {
        this.refresh()
        this.saveResultHandler2(resp.data)
        if (fromType === 2) {
          this.showCustomsPushRes(resp.data)
        }
      }).finally(() => loading.close())
    },
    saveResultHandler2(data) {
      // 保存十位码
      if (this.oneFormData.tenDigitCode && this.oneFormData.companyCname) {
        this.businessSaveOrUpdate()
      }
      this.closeHandler()
      this.$emit('successHandler', data)
    },
    async refresh() {
      if (this.job.uuid) {
        const curJob = await getJobByUuid(this.job.uuid).then(res => res.data)
        if (curJob) {
          this.job.version = curJob.version
        }
      }
    },
    showCustomsPushRes(data) {
      if (data && data.declareCustomsState && data.declareCustomsState === 15) {
        this.$message.success(this.$t('Message.SuccessfulCustoms'))
      } else {
        this.$message.error(this.$t('Message.FaildCustoms'))
      }
    },
    tenDigitCodeChangeHandler(event) {
      this.oneFormData.tenDigitCode = event.tenDigitCode
      if (this.oneFormData.tenDigitCode && this.oneFormData.tenDigitCode.trim().length > 10) {
        this.oneFormData.tenDigitCode = this.oneFormData.tenDigitCode.trim().substr(0, 10)
      }
      if (this.oneFormData.tenDigitCode.length === 10) {
        this.isQuerying = true
        getBusinessByTenDigitCode(this.oneFormData.tenDigitCode).then(res => this.resultHandler(res.data))
      }
    },
    queryBusinessHandler: function(event) {
      this.oneFormData.companyCname = event.companyCname
      if (this.oneFormData.companyCname && this.oneFormData.tenDigitCode.length !== 10) {
        this.isQuerying = true
        getBusinessByCompany(this.oneFormData.companyCname, false).then(res => this.resultHandler(res.data))
      }

      this.isQuerying = true
    },
    resultHandler(data) {
      this.isQuerying = false
      if (data && data.length > 0) {
        this.business = data[0]
        this.oneFormData.tenDigitCode = this.business.tenDigitCode
        this.oneFormData.companyCname = this.business.companyCname
      } else {
        this.business = null
      }
    },
    // 报关 保存后 保存或者更新 海关十字码
    businessSaveOrUpdate() {
      if (this.oneFormData.tenDigitCode.length !== 10) { return }

      if (!this.business || this.business.tenDigitCode !== this.oneFormData.tenDigitCode || this.business.companyCName !== this.oneFormData.companyCname) {
        // 公司名字被更新过
        const params = {
          tenDigitCode: this.oneFormData.tenDigitCode,
          companyCName: this.oneFormData.companyCname
        }
        businessCheckSaveUpdate(params)
      }
    },
    // 上穿成功回掉
    async updateSop(documentTypeUuid) {
      console.log(documentTypeUuid)
      this.toQuery()
    },
    /* 转换文件类型中文名称*/
    fileTypeLabelFunction: function(value) {
      return this.$t('CargoMsg.Cargo_Other')
    },
    /* 文件大小转换*/
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    // 查询文件
    async toQuery() {
      if (!this.oneFormData || !this.oneFormData.uuid) {
        return
      }
      this.storageURL = this.configMap.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
        this.oneFormData.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      await getFileList(xmlParam).then(res => {
        const files = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: ''
          }
        })
        this.rowData = files
      })
      this.getFilesSucceedHandler()
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      this.rowData = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      let fatherFile = this.rowData[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < this.rowData.length; i++) {
        childFile = this.rowData[i]
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      this.rowData = source
    },
    // 删除文件
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const self = this
      this.$confirm(this.$t('SeaExport.DeleteNumFile').replace('{0}', rows.length), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(async() => {
        try {
          for (const item of rows) {
            const isSuccess = await deleteFile(item.fileId).then(res => res.data === 'success')
            if (isSuccess) {
              item.isDeleted = true
            } else {
              break
            }
          }
        } finally {
          self.toQuery()
        }
      }).catch(() => {
      })
    },
    // 打开附件上传公共弹窗
    shouCloudUpload() {
      if (this.oneFormData.uuid === undefined || this.oneFormData.uuid === null || this.oneFormData.uuid === '') {
        this.$message.warning(this.$t('Message.CheckCustomsSaved'))
        return
      }
      this.cloudFile.lob = this.job.lob
      this.cloudFile.fromLob = 'OJ'
      this.cloudFile.job.lob = this.job.lob
      this.cloudFile.job.uuid = encodeURIComponent(this.oneFormData.uuid)
      this.cloudFile.uploadFiles = this.rowData
      this.cloudFile.visible = true
    },
    // 查看文件
    onFileView(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      // 测试 编辑保存
      // this.itemEditEndHandler(fileObject)

      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.currentUser.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.currentUser.userId) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToViewOrprinted'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data) {
      let documentType = data.extendMetaData.documentType
      if (documentType === this.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (result === null || result.length === 0) {
        return true
      }

      if (this.currentUser.admin || parseInt(data.createdBy) === this.currentUser.userId) {
        return true
      }

      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        this.$message.info(`[${data.fileName}]${this.$t('Message.TheToBeViewedAnyone')}`)
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      if (!isView) {
        this.$message.info(`${this.$t('Message.YouPermissionToViewDownload')}[${data.fileName}]${this.$t('Message.File')}`)
        return false
      }
      return true
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (var i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      var codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        var docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    closeHandler() {
      this.$emit('close')
    },
    initForm() {
      this.oneFormData = {
        level: '',
        tenDigitCode: '',
        companyCname: '',
        customsNo: '',
        mblNo: '',
        hblNo: '',
        soNo: '',
        goodsStoragePlace: '',
        lob: '',
        customsDate: '',
        distributionNo: '',
        distributionWarehouse: '',
        preCustomsDate: '',
        billOfLading: '',
        airportPort: '',
        declareCustomsState: 0,
        customsBroker: 0,
        exchangeService: 2,
        specialRelationshipOfBuyer: 2,
        includeRoyalty: 2,
        affectPrice: 2,
        woodPacking: 2,
        remarks: ''
      }
      this.txtAwbNo = ''
      this.txtAirportPort = ''
      this.txtMawbNo = ''
      this.txtHawbNo = ''
      this.rowData = []
    }
  }
}
</script>

<style>
</style>
